import { NavLink, useLocation } from 'react-router-dom';
// @mui
import { SxProps, styled, useTheme } from '@mui/material/styles';
import { Link, Typography } from '@mui/material';
// components
import { StackRow, StackRowForm } from 'src/components';
import { NavListProps } from './types';

// ----------------------------------------------------------------------

const RootStyle = styled(StackRowForm)(({ theme }) => ({
  justifyContent: 'space-between',
  '& a': {
    color: theme.palette.text.primary,
    padding: theme.spacing(1),
    textDecoration: 'none',
  },
  '& .active': {
    color: theme.palette.primary.main,
    '& svg > *': {
      fill: theme.palette.primary.main,
    },
    borderBottom: `3px solid ${theme.palette.primary.main}`,
  },
}));

// ----------------------------------------------------------------------

interface Props {
  menuItems: NavListProps[];
  onClick?: (v: string) => void;
  sx?: SxProps;
  actions?: React.ReactNode
}

const NavbarHorizontalV2: React.FC<Props> = ({ menuItems, onClick, sx, actions }) => {
  const theme = useTheme();
  const location = useLocation();


  return (
    <RootStyle sx={{ alignSelf: { xs: 'flex-start', md: 'initial' }, ...sx }}>
      <StackRow gap={1} flexWrap={'wrap'}>
      {menuItems?.filter(el => !el.hide).map((el: any) => {
        return !el?.path?.startsWith('#') ? (
          <NavLink
            key={el?.id + el?.path}
            to={el?.path}
            className={({ isActive }) => (isActive ? 'active' : 'inactive')}
          >
            <StackRow gap={1}>
              {el?.icon}
              {el?.title && <Typography>{el?.title}</Typography>}
            </StackRow>
          </NavLink>
        ) : (
          <Link
            key={el?.id + el?.path}
            href={el?.path}
            underline='none'
            onClick={(e) => {
              if (onClick) {
                e.preventDefault();
                onClick(el.path);
              }
            }}
            sx={{
              '&:hover > *': {
                color: theme.palette.primary.main,
                fill: theme.palette.primary.main,
              },
              '& > *': {
                color: location.hash === el.path ? theme.palette.primary.main : 'initial',
                fill: location.hash === el.path ? theme.palette.primary.main : 'initial',
              }
            }}
          >
            <StackRow gap={1}>
              {el?.icon}
              {el?.title && <Typography>{el?.title}</Typography>}
            </StackRow>
          </Link>
        );
      })}
      </StackRow>
      {actions}
    </RootStyle>
  );
};

export default NavbarHorizontalV2;
